import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSpecialDaysMutationVariables = Types.Exact<{
  days: Array<Types.InputMaybe<Types.OverrideDay>>;
}>;


export type UpdateSpecialDaysMutation = { __typename?: 'Mutation', updateSpecialDays?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', type: string, context?: string | null, location: Array<string> }> | null } | null };


export const UpdateSpecialDaysDocument = gql`
    mutation UpdateSpecialDays($days: [OverrideDay]!) {
  updateSpecialDays(days: $days) {
    errors {
      type
      context
      location
    }
  }
}
    `;
export type UpdateSpecialDaysMutationFn = Apollo.MutationFunction<UpdateSpecialDaysMutation, UpdateSpecialDaysMutationVariables>;

/**
 * __useUpdateSpecialDaysMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialDaysMutation, { data, loading, error }] = useUpdateSpecialDaysMutation({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useUpdateSpecialDaysMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpecialDaysMutation, UpdateSpecialDaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpecialDaysMutation, UpdateSpecialDaysMutationVariables>(UpdateSpecialDaysDocument, options);
      }
export type UpdateSpecialDaysMutationHookResult = ReturnType<typeof useUpdateSpecialDaysMutation>;
export type UpdateSpecialDaysMutationResult = Apollo.MutationResult<UpdateSpecialDaysMutation>;
export type UpdateSpecialDaysMutationOptions = Apollo.BaseMutationOptions<UpdateSpecialDaysMutation, UpdateSpecialDaysMutationVariables>;